import cx from 'classnames'

import type { WidgetConfig } from 'src/containers/WidgetsBar/hooks/types'

import classes from './styles.module.scss'

function WidgetComponent({ imgSrc, imgAlt, timer, color, onClick }: WidgetConfig) {
  return (
    <div className={cx(classes.root, classes.widgetContainer)} onClick={onClick}>
      <img src={imgSrc} alt={imgAlt} loading='lazy' />

      {timer && (
        <div className={cx(classes.timerSection, classes[color])}>
          <p>{timer}</p>
        </div>
      )}
    </div>
  )
}

export default WidgetComponent
